// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { InstrumentUtils } from '@shared/utils/Instruments/InstrumentUtils';
import { MathUtils } from '@shared/utils/MathUtils';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { MarkupFormula } from './MarkupFormula';
import Decimal from 'decimal.js';
export class ProfitCalculator {
    constructor(positon) {
        this.NetPL = 0;
        this.AccNetPL = 0;
        this.AccGrossPL = 0;
        this.NetGrossPL = 0;
        this.Position = positon;
        this.IsBuy = positon.BuySell === OperationType.Buy; // islong
    }
    // Long position P/L = Qty * Lot size * Cross price * (Current price  - Open price)
    // Short position P/L = Qty * Lot size * Cross price * (Open price  - Current price)
    Calculate() {
        // Type 1
        if (isNaN(this.Position.CurPriceClose)) {
            // TODO  Костылище!!!!!!!!!!!!!
            const last = this.Position.Instrument.Level1.GetLastPrice(this.Position.Account);
            if (!isNaN(last) && last !== this.Position.CurPriceClose) {
                this.Position.CurPriceClose = last;
                this.Position.lastPriceUpdated = true;
            }
        }
        // this.AccNetPL = this.CalculateAccNetPLByQty(this.Position.Amount)
        // let crossInstrumentUSD = DataCache.CrossRateCache.GetCrossPriceExp1(this.Position.Account.assetBalanceDefault.Asset.Name);
        // this.NetPL = this.AccNetPL * crossInstrumentUSD;
        // this.AccGrossPL = this.AccNetPL;
        // this.NetGrossPL = this.AccNetPL * crossInstrumentUSD;   // #87945
        // this.AccNetPL += this.Position.Swaps - this.Position.Commission;    // #88118
        const result = ProfitCalculator.GetPnLByPosition(this.Position);
        this.AccNetPL = result.netProfitAcc;
        this.NetPL = result.netProfitUSD;
        this.AccGrossPL = result.profitAcc;
        this.NetGrossPL = result.profitUSD;
    }
    CalculateAccNetPLByQty(Qty) {
        return ProfitCalculator.GetGrossPLByPositionAndCustomQuantity(this.Position, Qty);
    }
    static CalculateSLTP(Qty, CurPriceClose, OpenPrice, ins, account, isBuy, OpenCrossPrice, productType) {
        const side = OperationType[isBuy ? 'Buy' : 'Sell'];
        const curProductType = !isNullOrUndefined(productType) ? productType : null;
        const pnl = ProfitCalculator.GetPnL(new ProfitInputParams(ins, account, side, Qty, OpenPrice, OpenCrossPrice, CurPriceClose, null, null, curProductType));
        return pnl.profitAcc;
    }
    // Long position P/L = Qty * Lot size * (Current price * Current cross price - Open price * Open cross price)
    // Short position P/L = Qty * Lot size * (Open price * Open cross price - Current price * Current cross price)
    static GetUnitVolume(amount, lotSize) {
        return amount * lotSize;
    }
    static GetAmountExp1(side, amount, lotSize) {
        return ProfitCalculator.GetUnitVolume(amount, lotSize) * (side === OperationType.Buy ? 1 : -1);
    }
    static GetAmountExp1ByPosition(pos) {
        return ProfitCalculator.GetAmountExp1(pos.BuySell, pos.Amount, pos.Instrument.LotSize);
    }
    static GetAmountExp2Close(ins, side, qty, closePrice) {
        const lotSize = ins ? ins.LotSize : 1;
        const roundClosePrice = new Decimal(ins ? ins.roundPrice(closePrice) : closePrice);
        const amountExp1 = new Decimal(ProfitCalculator.GetAmountExp1(side, qty, lotSize));
        return amountExp1.mul(roundClosePrice).toNumber();
    }
    static GetAmountExp2Open(side, qty, lotSize, openPrice) {
        const roundOpenPrice = new Decimal(MathUtils.TruncateDouble(openPrice, InstrumentUtils.MAX_PRECISION_ON_SERVER));
        const amountExp1 = new Decimal(-ProfitCalculator.GetAmountExp1(side, qty, lotSize));
        return amountExp1.mul(roundOpenPrice).toNumber();
    }
    static GetAmountExp2OpenByPosition(pos) {
        return ProfitCalculator.GetAmountExp2Open(pos.BuySell, pos.Amount, pos.Instrument.LotSize, pos.Price);
    }
    static GetPnL(inputParams) {
        const account = inputParams.Account;
        const instrument = inputParams.Instrument;
        const dataCache = instrument.DataCache;
        const productType = inputParams.ProductType;
        const side = inputParams.Side;
        const crossInstrumentAccDouble = dataCache.CrossRateCache.GetCrossPriceInsSideExp2(account, instrument, side);
        const crossInstrumentAccDecimal = crossInstrumentAccDouble;
        const openCrossPriceDecimal = inputParams.OpenCrossPrice;
        const crossAccountUSD = dataCache.CrossRateCache.GetCrossPriceExp1(account.BaseCurrency, account);
        const crossInstrumentUSD = dataCache.CrossRateCache.GetCrossPriceIns(account, instrument, side);
        const ticCost = instrument.GetTickCost();
        const amount = inputParams.Amount;
        const lotSize = instrument ? instrument.LotSize : 1;
        const amountExp2OpenDecimal = ProfitCalculator.GetAmountExp2Open(side, amount, lotSize, inputParams.OpenPrice);
        const amountExp2CloseDecimal = ProfitCalculator.GetAmountExp2Close(instrument, side, amount, inputParams.ClosePrice);
        const markupObj = account.CrossratesPlan && instrument
            ? account.CrossratesPlan.GetMarkup(instrument.Exp2, account.BaseCurrency, crossInstrumentAccDouble, instrument, side === OperationType.Buy)
            : { markup: 0, formula: MarkupFormula.None };
        const markupInstrumentAcc = markupObj.markup;
        const formula = markupObj.formula;
        let profitUSD, profitAcc;
        const rps = account.RiskPlan.riskPlanCache.getRiskPlanSettings(instrument, productType, 'UseSameCrossPriceForOpenClose');
        const UseSameCrossPriceForOpenClose = rps.getValue(productType, 'UseSameCrossPriceForOpenClose');
        if (UseSameCrossPriceForOpenClose || openCrossPriceDecimal === 0) {
            // профит в серверной валюте, без маркапа (разница цен * кросс)
            profitUSD = (amountExp2OpenDecimal + amountExp2CloseDecimal) * crossInstrumentUSD * ticCost;
            if (formula === MarkupFormula.OpenAndClose) {
                // 1я формула, маркап применяется к обоим кроссам открытия и закрытия
                profitAcc =
                    (amountExp2OpenDecimal * (crossInstrumentAccDecimal + markupInstrumentAcc) +
                        amountExp2CloseDecimal * (crossInstrumentAccDecimal - markupInstrumentAcc)) *
                        ticCost;
            }
            else if (formula === MarkupFormula.Pnl || formula === MarkupFormula.MarginOpenAndClose) {
                // знак перед маркапом определяется знаком текущего пнл
                const pnl = amountExp2OpenDecimal + amountExp2CloseDecimal;
                profitAcc =
                    pnl * (crossInstrumentAccDecimal - Math.sign(pnl) * Math.abs(markupInstrumentAcc)) * ticCost;
            }
            else {
                // без маркапа (разница цен * кросс)
                profitAcc = (amountExp2OpenDecimal + amountExp2CloseDecimal) * crossInstrumentAccDecimal * ticCost;
            }
        }
        else {
            // профит в серверной валюте, без маркапа (открыте*кросс1 + закрыте*кросс2 )
            profitUSD =
                (amountExp2OpenDecimal * openCrossPriceDecimal * crossAccountUSD +
                    amountExp2CloseDecimal * crossInstrumentUSD) *
                    ticCost;
            if (formula === MarkupFormula.OpenAndClose) {
                // маркапим кросс закрытия, открытие уже сервер промаркапил
                profitAcc =
                    (amountExp2OpenDecimal * openCrossPriceDecimal +
                        amountExp2CloseDecimal * (crossInstrumentAccDecimal - markupInstrumentAcc)) *
                        ticCost;
            }
            else {
                // для всех других случаев - без маркапа
                profitAcc =
                    (amountExp2OpenDecimal * openCrossPriceDecimal +
                        amountExp2CloseDecimal * crossInstrumentAccDecimal) *
                        ticCost;
            }
        }
        const faceValueMultiplier = instrument.GetFaceValueMultiplier();
        profitUSD *= faceValueMultiplier;
        profitAcc *= faceValueMultiplier;
        // профит (как положительный так и отрицательный) - это базис
        // если комиссия положительна, это деньги, которые СНИМУТСЯ со счета (если отриц. - добавятся) потому "-комиссия"
        // свопы наоборот, положителен, если наутро деньги будут прибавлены, поэтому "+своп"
        const swaps = inputParams.Swaps || 0;
        const commissions = inputParams.Commissions || 0;
        const netProfitUSD = profitUSD + (swaps - commissions) * crossAccountUSD;
        const netProfitAcc = profitAcc + (swaps - commissions);
        return { profitUSD, profitAcc, netProfitUSD, netProfitAcc };
    }
    static GetPnLByPosition(position) {
        return ProfitCalculator.GetPnL(ProfitInputParams.CreateFromPosition(position));
    }
    static GetGrossPLByPositionAndCustomQuantity(position, qty) {
        const inputParams = ProfitInputParams.CreateFromPosition(position);
        inputParams.Amount = qty;
        const pnlFull = ProfitCalculator.GetPnL(inputParams);
        return pnlFull.profitAcc;
    }
}
export class ProfitInputParams {
    constructor(instrument, account, side, amount, openPrice, openCrossPrice, closePrice, swaps, commissions, productType) {
        this.Instrument = instrument;
        this.Account = account;
        this.Side = side;
        this.Amount = amount;
        this.OpenPrice = openPrice;
        this.OpenCrossPrice = openCrossPrice;
        this.ClosePrice = closePrice;
        this.Swaps = swaps;
        this.Commissions = commissions;
        this.ProductType = productType;
    }
    static CreateFromPosition(pos) {
        return new ProfitInputParams(pos.Instrument, pos.Account, pos.BuySell, pos.Amount, pos.Price, pos.OpenCrossPrice, pos.CurPriceCloseNotRounded, pos.Swaps, pos.Commission, pos.ProductType);
    }
}
